/**
 * Determine if a variable is an object
 *
 * @param {*} obj
 */

const isObject = function(obj) {
  var type = typeof obj;
  return type === "function" || (type === "object" && !!obj);
};

export default isObject;
